/**
 * @generated SignedSource<<155863546fbc17013d15e978d92f7a01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeletePriorityLevelModal_company$data = {
  readonly id: string;
  readonly priorityLevels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly weight: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "DeletePriorityLevelModal_company";
};
export type DeletePriorityLevelModal_company$key = {
  readonly " $data"?: DeletePriorityLevelModal_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeletePriorityLevelModal_company">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeletePriorityLevelModal_company",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "PriorityLevelTypeConnection",
      "kind": "LinkedField",
      "name": "priorityLevels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PriorityLevelTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PriorityLevel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "weight",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "priorityLevels(first:1000)"
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "f92d19934295a4c4f31030c447a4e8ec";

export default node;
